export const CONTENT_DRAFT_STORAGE_KEY = 'moment_content_draft'
export const TITLE_DRAFT_STORAGE_KEY = 'moment_title_draft'
export const TAGS_DRAFT_STORAGE_KEY = 'moment_tags_draft'
